const colors = {
  brand: {
    'trygg-hansa': '#f00001',
    evidensia: '#095b6f',
    'evidensia-light': '#edf6f9',

    'cream-light': '#fffbf7',
    cream: '#f8f0e8',
    'cream-dark': '#f4e8dc',
    'cream-darker': '#eedecd',

    'green-light': '#eaf0ea',
    'green-semilight': '#cfe5ce',
    green: '#2f8840',
    'green-dark': '#374f39',

    'brown-light': '#482c23',
    brown: '#301911',
    'brown-dark': '#1e100b',

    pink: '#f9a8c9',
    yellow: '#fcd34d',
    sky: '#7cc4f0',
    lilac: '#c4b5fd',
  },
  stone: {
    '50': '#fafaf9',
    '100': '#f5f5f4',
    '200': '#e7e5e4',
    '300': '#d6d3d1',
    '400': '#a8a29e',
    '500': '#78716c',
    '600': '#57534e',
    '700': '#44403c',
    '800': '#292524',
    '900': '#1c1917',
    '950': '#0c0a09',
  },
  orange: {
    '50': '#fff7ed',
    '100': '#ffedd5',
    '200': '#fed7aa',
    '300': '#fdba74',
    '400': '#fb923c',
    '500': '#f97316',
    '600': '#ea580c',
    '700': '#c2410c',
    '800': '#9a3412',
    '900': '#7c2d12',
    '950': '#431407',
  },
};

export default colors;
